import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forWho = ['Padres y madres que trabajan tiempo completo y llegan exhaustos a casa.', 'Personas que viven en EE. UU. y quieren dejar de gastar fortunas en UberEats o Drive-Thrus.', 'Quienes buscan comer saludable pero odian pasar horas en la cocina.', 'Familias que necesitan soluciones prácticas con ingredientes que se encuentran en cualquier supermercado común.'];
const notForWho = ['Personas que disfrutan pasar 2 horas cocinando platos gourmet cada noche.', 'Quienes no tienen acceso a un supermercado básico.', 'Gente que busca una dieta médica específica o restrictiva.'];
export function WhoIsFor() {
  return <section className="py-24 px-4 bg-brand-bg" data-id="element-208">
      <div className="max-w-5xl mx-auto" data-id="element-209">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-210">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-green-light/30 border border-brand-green/20 p-8 rounded-3xl" data-id="element-211">
            <h3 className="text-3xl mb-8 text-brand-dark" data-id="element-212">Para Ti Si...</h3>
            <ul className="space-y-6" data-id="element-213">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-214">
                  <div className="bg-brand-green text-white p-1 rounded-full flex-shrink-0 mt-1" data-id="element-215">
                    <CheckIcon className="w-4 h-4" strokeWidth={3} data-id="element-216" />
                  </div>
                  <span className="text-stone-700 leading-relaxed font-medium" data-id="element-217">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-red-light/30 border border-brand-red/20 p-8 rounded-3xl" data-id="element-218">
            <h3 className="text-3xl mb-8 text-brand-dark" data-id="element-219">
              NO Es Para Ti Si...
            </h3>
            <ul className="space-y-6" data-id="element-220">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-221">
                  <div className="bg-brand-red text-white p-1 rounded-full flex-shrink-0 mt-1" data-id="element-222">
                    <XIcon className="w-4 h-4" strokeWidth={3} data-id="element-223" />
                  </div>
                  <span className="text-stone-700 leading-relaxed" data-id="element-224">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}